<div *ngFor="let customer of customersDetailList;">
  <mat-card appearance="outlined" tabindex="0" (keyup.enter)="customerSelect(customer)" (click)="customerSelect(customer)" [ngClass]="'margin_left_2 ta-customerlist-' + customer.nameId.toLowerCase()">
    <mat-card-header>
      <div *ngIf="!forSalesOrder" mat-card-avatar class="fa fa-user-circle fa-3x"></div>
      <mat-card-title>{{customer.name}}- ({{customer.nameId}})</mat-card-title>
      <mat-card-subtitle>
        <div [style.display]="customer.addressline1 != '' ? 'block' : 'none'">{{customer.addressline1}},</div>
        <div [style.display]="customer.addressline2 != '' ? 'block' : 'none'">{{customer.addressline2}}</div>
        <div [style.display]="customer.city != '' ? 'block' : 'none'">{{customer.city}}, {{customer.state}}</div>
        <div [style.display]="customer.phoneNumber != '' ? 'block' : 'none'">{{customer.phoneNumber}}</div>
        <div
          [style.display]="customer.primaryContact && customer.primaryContact.ContactInformation!='' ? 'block' : 'none'">
          {{customer.primaryContact.ContactInformation}}</div>
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>
  <br>
</div>